import {REGEX_CAR_PLATE} from '../../../base.js'
import {TRANNSMISSION_TYPE_ID_MANUAL} from '../../ads.js'
import {
  getConfigFields,
  getEmptyFieldRule,
  getMaxLengthConstraint,
  getNotNullConstraint,
  getPatternConstraint,
  getRemoteFieldRule
} from '../fields.js'
import {formFieldIds} from '../values.js'

const {
  comments,
  makeId,
  modelId,
  bodyTypeDoorsId,
  fuelId,
  yearId,
  versionId,
  transmissionTypeId,
  hidePhone,
  kilometersId,
  price,
  colour,
  environmentalLabel,
  plate,
  plateRegistrationDate,
  publishInMA,
  recommendedPrice
} = formFieldIds

const formPublishAdFieldsConfig = [
  getConfigFields[makeId](),
  getConfigFields[modelId](),
  getConfigFields[bodyTypeDoorsId](),
  getConfigFields[fuelId](),
  getConfigFields[yearId](),
  getConfigFields[versionId]({customProps: {help: 'PUBLISH_AD.FB.VERSIONS.HELP'}}),
  getConfigFields[transmissionTypeId]({customProps: {label: 'COMMON.TRANSMISSION_TYPE'}}),
  getConfigFields[environmentalLabel](),
  getConfigFields[colour](),
  getConfigFields[kilometersId]({
    customProps: {
      help: 'PUBLISH_AD.FB.KMS.COCHES.HELP',
      label: 'COMMON.KMS',
      constraints: [
        getNotNullConstraint({
          message: 'PUBLISH_AD.FB.KMS.COCHES.CONSTRAINTS.NOTNULL'
        }),
        getMaxLengthConstraint({
          value: 7
        }),
        getPatternConstraint({
          message: 'PUBLISH_AD.FB.KMS.COCHES.CONSTRAINTS.MIN',
          pattern: /^[\d.]{4,}$/.source
        })
      ]
    }
  }),
  getConfigFields[recommendedPrice](),
  getConfigFields[price]({
    customProps: {
      constraints: [
        getNotNullConstraint({
          message: 'PUBLISH_AD.FB.PRIZES.COCHES.CONSTRAINTS.NOTNULL'
        }),
        getPatternConstraint({
          message: 'PUBLISH_AD.FB.PRIZES.COCHES.CONSTRAINTS.MIN',
          pattern: /^(?:[3-9]\d{2,}|[\d.]{4,})$/.source
        }),
        getMaxLengthConstraint({value: 9})
      ]
    }
  }),
  getConfigFields[plate]({
    customProps: {
      help: 'FORM.PLATE.HELP_NEVER_WILL_BE_PUBLISHED',
      // ff_web_seller_show_pta_multitenant
      // TO DO : make PTA coches use plate id
      id: 'carPlate',
      label: 'FORM.PLATE.LABEL_OPTIONAL',
      required: false,
      constraints: [
        getMaxLengthConstraint({value: '8'}),
        getPatternConstraint({
          message: 'FORM.PLATE.ERROR_NOT_VALID',
          pattern: REGEX_CAR_PLATE.source
        })
      ]
    }
  }),
  getConfigFields[plateRegistrationDate]()
]

const formPublishAdFieldsWithRemotePropertyOrder = [makeId, modelId, bodyTypeDoorsId, fuelId, yearId, versionId]

const getFormPublishAdRules = () => {
  const rules = {}

  formPublishAdFieldsWithRemotePropertyOrder.forEach((fieldId, fieldIdIndex) => {
    if (!fieldIdIndex) return
    const previousFields = formPublishAdFieldsWithRemotePropertyOrder.slice(0, fieldIdIndex)
    const fieldRules = previousFields.map((previousFieldId, previousFieldIdIndex) => {
      return previousFieldIdIndex === previousFields.length - 1
        ? getRemoteFieldRule({id: previousFieldId})
        : getEmptyFieldRule({id: previousFieldId})
    })
    rules[fieldId] = fieldRules
  })

  return rules
}

const formPublishAdInitialValues = {
  [bodyTypeDoorsId]: '',
  [colour]: '',
  [comments]: '',
  [environmentalLabel]: 'UNSPECIFIED',
  [fuelId]: '',
  [hidePhone]: true,
  [kilometersId]: '',
  [makeId]: '',
  [modelId]: '',
  // ff_web_seller_show_pta_multitenant
  // TO DO : make PTA coches use plate id
  // [plate]: '',
  [`carPlate`]: '',
  [plateRegistrationDate]: '',
  [price]: '',
  [publishInMA]: true,
  [recommendedPrice]: '',
  [transmissionTypeId]: TRANNSMISSION_TYPE_ID_MANUAL.toString(),
  [versionId]: '',
  [yearId]: ''
}

export const formPublishAdFormConfig = {
  fields: formPublishAdFieldsConfig,
  initialValues: formPublishAdInitialValues,
  lockedFieldsOnEdition: [makeId, modelId, bodyTypeDoorsId, fuelId, yearId],
  remotes: formPublishAdFieldsWithRemotePropertyOrder,
  rules: getFormPublishAdRules()
}
